import { connect } from 'react-redux'
import { lifecycle, compose, withHandlers } from 'recompose'
import withType from 'components/common/hoc/withType'
import toggle from 'components/common/hoc/toggle'
import { getHasActiveVehicleStatus } from 'selectors'
import { getLocationPathname } from 'selectors/getPageLocation'
import { getActiveVehicleName } from 'selectors/getActiveVehicle'
import { generateSchemaUrl } from 'helpers/SEOSchema'
import { setBrandData } from '../../actions'
import BrandDetail from './BrandDetail'

const mapStateToProps = (state, { details: { name, ...details }}) => {
  const hasActiveVehicle = getHasActiveVehicleStatus(state)
  const schemaUrl = generateSchemaUrl(getLocationPathname(state))
  let heading

  if (!hasActiveVehicle) {
    const { nrOfTiresForTheBrand: count } = details

    heading = `We have over ${count} ${name} Tire Lines Available!`
  } else {
    const { nrOfTiresForTheBrandAndVehicle: count } = details
    const vehicleName = getActiveVehicleName(state)
    const isPlural = count !== 1
    heading = `There ${isPlural ? 'are' : 'is'} ${count} ${name} Tire Line${isPlural ? 's' : ''}
     compatible with your ${vehicleName}`
  }

  return {
    heading,
    schemaUrl,
    hasActiveVehicle
  }
}

const withToggleHandlers = withHandlers({
  toggleOnClick: ({ toggleHandlers: { onClick } = {}}) => e => {
    if (e.target && e.target.attributes['data-toggle-link']) {
      e.preventDefault()
      onClick(e)
    }
  }
})

const withBrandDetailsLifecycle = lifecycle({
  componentDidMount() {
    this.props.setBrandData(this.props.details)
  },
  componentDidUpdate({ details: prevDetails }) {
    const { setBrandData, details } = this.props

    if (details !== prevDetails) {
      setBrandData(details)
    }
  }
})

export default compose(
  toggle,
  withType({ type: 'BrandDetail' }),
  connect(mapStateToProps, { setBrandData }),
  withToggleHandlers,
  withBrandDetailsLifecycle
)(BrandDetail)
